export default "__VITE_ASSET__DSQkgiHl__"